import { useEffect, useMemo, useRef } from 'react'
import { Box, Dialog, DialogContent, LinearProgress, Typography } from '@mui/material'
import { CHECK_STATUS } from 'api/checkresponse'
import { useAppSelector, useAppDispatch } from 'store/hooks'
import { selectCheckresponse, checkresponse } from 'slices/checkresponseSlice'
import { selectStartdelivery } from 'slices/startdeliverySlice'

export const Uploading = () => {
  const intervalRef = useRef<NodeJS.Timeout | null>(null)

  const dispatch = useAppDispatch()
  const { response } = useAppSelector(selectCheckresponse)
  const { sessionId } = useAppSelector(selectStartdelivery)

  const progressRate = useMemo(() => {
    if (response) {
      return Math.min(Math.trunc((response.elapsedTime / response.waitTime) * 100), 100)
    }
    return 0
  }, [response])

  const open = useMemo(() => response?.status === CHECK_STATUS.CONTINUE, [response?.status])

  useEffect(() => {
    if (open) {
      intervalRef.current = setInterval(() => dispatch(checkresponse(sessionId)), 3000)
    }
  }, [dispatch, open, sessionId])

  useEffect(() => {
    if (!open && intervalRef.current) {
      clearInterval(intervalRef.current)
      intervalRef.current = null
    }
  }, [open])

  return (
    <Dialog open={open} fullWidth>
      <DialogContent>
        <Typography pb={2}>連絡中です</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', pb: 2 }}>
          <Box sx={{ width: '100%', mr: 1 }}>
            <LinearProgress variant="determinate" value={progressRate} />
          </Box>
          <Box sx={{ minWidth: 35 }}>
            <Typography variant="body2" color="text.secondary">
              {progressRate}%
            </Typography>
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
